const config = {
  baseUrl: 'https://login.adgebra.co',
  // baseUrl: 'https://qabrand.inuxu.net',
  trackerDomain: 'https://adgebra.co.in'
};

export default config;
